export enum ProfileStatus {
  ACTIVE = "active",
  PENDING = "pending",
  DEACTIVATED = "deactivated",
}
export type ProfileType = {
  id: string
  name: string
  school: string
  lastActive: string | null
  dateAdded: string
  status: ProfileStatus
  avatarColor: string
  email: string
}
export enum DialogEnum {
  VIEW_DETAILS = "view-details",
  ACCOUNT_STATUS = "account-status",
  ADD_SCHOOL = "add-school",
  ADD_MULTIPLE_TEACHER = "add-multiple-teacher",
  ADD_A_TEACHER = "add-a-teacher",
}
export type SortField = "name" | "lastActive" | "dateAdded"
export type SortDirection = "asc" | "desc" | null
